export enum StatusArquivoImportacaoEnum {
  Pendente = 0,
  Validando = 1,
  Sucesso = 2,
  Alerta = 3,
  Erro = 4,
}
